import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Text } from '@chakra-ui/react'

import { Item } from 'appTypes/mapper'
import { ButtonText } from 'components/ui/Buttons/Button'
import ProductBundle from 'components/ui/ProductBundle'
import { Container } from 'styles/shared'

type Props = {
  bundles: Item[]
  shouldHideTitleOnDesktop?: boolean
}

export const ProductBundles: React.FC<Props> = ({ bundles, shouldHideTitleOnDesktop = true }) => {
  const { t } = useTranslation('common')

  return (
    <>
      <Container>
        <Flex
          marginTop="36px"
          justifyContent="space-between"
          alignItems="center"
          display={{
            base: 'flex',
            md: shouldHideTitleOnDesktop ? 'none' : 'flex',
          }}
        >
          <Text fontSize="sm">{t('productBundles')}</Text>
          <ButtonText href="/bundles">{t('showAll')}</ButtonText>
        </Flex>
      </Container>

      <Flex
        overflowX={{ base: 'scroll', lg: 'hidden' }}
        paddingBottom="12px"
        marginTop="12px"
        paddingLeft={{ base: '20px', lg: 0 }}
        maxWidth="1320px"
        marginX="auto"
      >
        {bundles.map((bundle: Item, index: number) => (
          <Box minWidth="320px" key={index} marginRight="12px">
            <ProductBundle bundle={bundle} />
          </Box>
        ))}
      </Flex>
    </>
  )
}
